import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import classList from 'flarum/common/utils/classList';
import LanguageDisplay from './components/LanguageDisplay';
import chooseLanguage from './utils/chooseLanguage';
import { composerFields, isPrivateComposer, startingLanguage } from './utils/composerLanguage';
import { selectedLanguage } from './utils/languageFilter';
export default () => {
  // Here rather than where the composer is opened: loading the composer's chunk
  // clears its fields, and it can be opened from anywhere.
  extend('flarum/forum/components/DiscussionComposer', 'oninit', function () {
    if (isPrivateComposer(this) || composerFields(this).language) return;
    const code = startingLanguage(selectedLanguage(), !!app.forum.attribute('fof-discussion-language.composerLocaleDefault'), app.translator.getLocale());
    composerFields(this).language = code && app.store.getBy('discussion-languages', 'code', code) || null;
  });
  extend('flarum/forum/components/DiscussionComposer', 'headerItems', function (items) {
    if (isPrivateComposer(this)) return;
    const language = composerFields(this).language;
    items.add('language', m(Button, {
      className: "DiscussionComposer-changeTags Button Button--ua-reset",
      onclick: () => chooseLanguage(this, true)
      // The language is shown by a component, which the button can't read a name from.
      ,
      "aria-label": language?.name()
    }, m("span", {
      className: classList('LanguageLabel', !language && 'none')
    }, language ? m(LanguageDisplay, {
      language: language,
      uppercase: true
    }) : app.translator.trans('fof-discussion-language.forum.composer_discussion.choose_language_link'))), 20);
  });
  override('flarum/forum/components/DiscussionComposer', 'onsubmit', function (original) {
    if (isPrivateComposer(this) || composerFields(this).language) return original();
    chooseLanguage(this, true, original);
  });
  extend('flarum/forum/components/DiscussionComposer', 'data', function (data) {
    const language = composerFields(this).language;
    if (isPrivateComposer(this) || !language) return;
    data.relationships = {
      ...data.relationships,
      language
    };
  });
};